module.exports = __webpack_public_path__ + "static/media/Tiktok.e806689c.png";